import { DesignTokens } from '../brands';
import sharedDsTokens from '../default/ds-tokens';

const dsTokens: DesignTokens = {
  ...sharedDsTokens,
  colors: {
    ...sharedDsTokens.colors,
    'brand-1': '#0C0D0D',
    'brand-2': '#F0F5F1',
    'brand-3': '#151E18',
    'dark-dark': '#3D4042',
    'dark-light': '#3D4042',
    actionNavigationStandardStatic: '#006647',
    actionNavigationStandardHighlight: '#004D36',
    actionNavigationStandardDisabled: 'rgba(0, 0, 0, 0.16)',
    actionNavigationAltHighlight: '#ffffffe0',
    actionNavigationAltDisabled: 'rgba(255, 255, 255, 0.24)',
    actionConversionStatic: '#181A1B',
    actionConversionHighlight: '#0C0D0D',
    actionConversionDisabled: 'rgba(255, 255, 255, 0.24)',
    'medium-light-1': '#0C0D0D',
    'medium-light-2': '#F2F2F3',
    'medium-medium': '#62666A',
    nonInteractiveEmphasis: '#496954',
  },
  fonts: {
    primary:
      'DM Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
    secondary:
      'DM Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  },
};

export default dsTokens;
